<template>
  <div
    :class="[mobile ? 'flex flex-col items-center justify-center w-full' : '']"
    class="h-full overflow-visible"
  >
    <!-- GUEST MENU -->
    <ul
      id="tenantMenu"
      :class="
        mobile
          ? 'flex flex-col items-center lg:justify-center justify-start w-full'
          : ''
      "
      class="overflow-y-auto no-scrollbar relative transition duration-150 ease-in-out"
    >
      <!-- DEFAULT PAGES -->
      <li
        class="menu-item py-2 px-6 w-full cursor-pointer hover:text-expo_red hover:bg-bluegray-100"
        :class="[
          mobile ? 'text-center' : '',
          { active: 'home' === activeMenuItem },
          'home' === activeMenuItem ? 'bg-bluegray-100' : '',
        ]"
        @click="pushRoute('Home')"
      >
        {{ settings.profile_title }}
      </li>
      <li
        class="menu-item py-2 px-6 w-full cursor-pointer hover:text-expo_red hover:bg-bluegray-100"
        :class="[
          mobile ? 'text-center' : '',
          { active: 'posts' === activeMenuItem },
          'posts' === activeMenuItem ? 'bg-bluegray-100' : '',
        ]"
        @click="pushRoute('Posts')"
      >
        Posts
      </li>

      <!-- DYNAMIC PAGES -->
      <li
        v-for="(parent, i) in menu"
        :key="i"
        :ref="'menu-item' + i"
        :class="[
          mobile ? 'text-center' : '',
          {
            active: parent.id === activeMenuItem,
            ddActive: parent.id === activeDropdown,
          },
          parent.id === activeMenuItem ? 'bg-bluegray-200' : '',
        ]"
        class="menu-item w-full relative flex flex-wrap items-center group"
      >
        <div
          v-if="parent.children.length >= 1"
          :class="activeDropdown === parent.id ? 'bg-bluegray-200' : ''"
          class="w-full cursor-pointer pt-2 hover:bg-bluegray-200 hover:text-expo_red"
        >
          <div
            class="pb-2 w-full flex items-center justify-center lg:justify-start"
            :class="[
              mobile ? '' : 'px-6',
              activeDropdown === parent.id ? 'text-expo_red' : '',
            ]"
            @click="toggleMenuItemDD(parent.id)"
          >
            <span>{{ parent.title }}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="lg:ml-auto h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </div>

          <!-- DROPDOWN PAGES -->
          <div
            :class="[
              parent.id === activeDropdown
                ? 'w-full flex-shrink-0 opacity-1'
                : 'opacity-0 pointer-events-none',
            ]"
            class="sub-menu h-full w-full shadow-inner"
          >
            <ul
              :style="{ maxHeight: '400px' }"
              class="w-full h-full overflow-scroll no-scrollbar"
            >
              <li
                v-if="parent.page_type !== 2"
                class="px-6 py-2 transition-all duration-300 hover:bg-bluegray-200 menu-item w-full flex items-center space-x-1 justify-center lg:justify-start cursor-pointer hover:text-expo_red"
                @click="pushToPageRoute(parent)"
              >
                <p class="pr-2">-</p>
                <span>{{ parent.title }}</span>
                <svg
                  v-if="parent.page_type === 1"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3 opacity-50"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
              </li>
              <li
                v-for="(child, j) in parent.children"
                :key="j"
                class="flex items-center space-x-1 justify-center lg:justify-start px-6 py-2 transition-all duration-300 hover:bg-bluegray-200 menu-item w-full cursor-pointer hover:text-expo_red"
                @click="pushToPageRoute(child)"
              >
                <p class="pr-2">-</p>
                <span>{{ child.title }}</span>
                <svg
                  v-if="child.page_type === 1"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3 opacity-50"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
              </li>
            </ul>
          </div>
        </div>

        <div
          v-else
          :class="[mobile ? '' : 'px-6']"
          class="w-full cursor-pointer flex items-center space-x-1 justify-center lg:justify-start py-2 hover:text-expo_red hover:bg-bluegray-200"
          @click="pushToPageRoute(parent)"
        >
          <span>{{ parent.title }}</span>
          <svg
            v-if="parent.page_type === 1"
            xmlns="http://www.w3.org/2000/svg"
            class="h-3 w-3 opacity-50"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </div>
      </li>

      <li
        v-if="settings.enabled_contact"
        class="menu-item py-2 px-6 w-full cursor-pointer hover:text-expo_red hover:bg-bluegray-100"
        :class="[
          mobile ? 'text-center' : '',
          { active: 'home' === activeMenuItem },
          'home' === activeMenuItem ? 'bg-bluegray-100' : '',
        ]"
        @click="contact"
      >
        Contact
      </li>

      <li
        class="hidden lg:block menu-item py-2 px-6 w-full cursor-pointer hover:text-expo_red hover:bg-bluegray-100"
        :class="[
          mobile ? 'text-center' : '',
          { active: 'posts' === activeMenuItem },
          'posts' === activeMenuItem ? 'bg-bluegray-100' : '',
        ]"
        @click="backToExpo"
      >
        Back to Online Expo
      </li>

      <li
        class="block lg:hidden btn btn-primary uppercase cursor-pointer p-4 mt-4"
        @click="backToExpo"
      >
        Back to Online Expo
      </li>
    </ul>
    <div
      v-if="isOverflowing"
      class="menu-overflow relative text-bluegray-500 pl-6"
    >
      <h6 class="text-xs mt-2 pb-2">Scroll down</h6>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M16 17l-4 4m0 0l-4-4m4 4V3"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import { shared } from '../../../js/mixins/shared.js'
import { mapGetters } from 'vuex'

export default {
  mixins: [shared],

  props: {
    mobile: { default: false },
  },

  data() {
    return {
      isOverflowing: false,
      activeMenuItem: 'Home',
      activeDropdown: 0,
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      isAdministrator: 'shared/getUserAccess',
      menu: 'shared/getMenu',
    }),
  },

  mounted() {
    setTimeout(() => {
      this.checkOverflow()
    }, 10)
  },

  methods: {
    backToExpo() {
      let url = this.settings.cloud_domain
      if (url) {
        window.location.href = url
      }
    },

    testOverflowing(element) {
      if (element.scrollHeight - element.clientHeight > 1) {
        return true
      }
    },

    pushRoute(route) {
      if (this.$router.currentRoute.name !== route) {
        EventBus.$emit('NonManagerRouteClicked')
        this.$router.push({ name: route })
      }
      EventBus.$emit('closeMobileMenu')
    },

    toggleMenuItemDD(id) {
      if (this.activeDropdown !== id) {
        this.$set(this, 'activeDropdown', id)
      } else {
        this.$set(this, 'activeDropdown', 0)
      }
      setTimeout(() => {
        this.checkOverflow()
      }, 10)
    },

    pushToPageRoute(item) {
      let url = item.external_link
      if (item.external_link && this.validateURL(url)) {
        if (!this.validateURLProtocol(url)) {
          url = this.updateURLWithProtocol(url)
        }
        window.location.href = url
        return
      }
      let id = item.id
      this.$set(this, 'activeDropdown', 0)
      EventBus.$emit('NonManagerRouteClicked')
      this.$router.push({ path: '/page/' + id })
      EventBus.$emit('closeMobileMenu')
    },

    contact() {
      EventBus.$emit('showModal', 'contact')
      EventBus.$emit('closeMobileMenu')
    },

    checkOverflow() {
      let overflowMenu = document.getElementById('tenantMenu')
      if (overflowMenu) {
        let overflowing =
          overflowMenu.scrollHeight - overflowMenu.clientHeight > 1
        this.$set(this, 'isOverflowing', overflowing)
      }
    },
  },
}
</script>

<style scoped>
.menu-overflow:after {
  width: 100%;
  height: 15px;
  content: '';
  position: absolute;
  bottom: 48px;
  left: 0;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 25%,
    rgba(255, 255, 255, 0) 100%
  );
}

.sub-menu {
  display: none;
}
.ddActive .sub-menu {
  display: block;
  max-height: 500px;
}

#tenantMenu {
  max-height: 65vh;
}

/* available space for the menu taking into consideration logo + subscribe */
@media screen and (min-width: 1024px) {
  #tenantMenu {
    height: 63%;
  }
}

@media screen and (max-width: 1024px) {
  .menu-overflow:after {
    display: none;
  }
}
</style>
